import React, { createContext, useState } from 'react'

import { IAreasAtuacaoResponse, IFaixaFuncionariosResponse, IGraduacaoMultasGetAllResponse, IInfracoesResponse } from 'services/GST/GraduacaoMultas'

interface IUseFineGraduation {
  multaSelecionada: IGraduacaoMultasGetAllResponse
  setMultaSelecionada: React.Dispatch<React.SetStateAction<IGraduacaoMultasGetAllResponse>>
  areasObjList: IAreasAtuacaoResponse[] 
  setAreasObjList: React.Dispatch<React.SetStateAction<IAreasAtuacaoResponse[]>>
  faixaFuncionariosObjList: IFaixaFuncionariosResponse[]
  setFaixaFuncionariosObjList: React.Dispatch<React.SetStateAction<IFaixaFuncionariosResponse[]>>
  infracoesObjList: IInfracoesResponse[]
  setinfracoesObjList: React.Dispatch<React.SetStateAction<IInfracoesResponse[]>>
}

export const FineGraduationContext = createContext<IUseFineGraduation>(null)

export const FineGraduationProvider: React.FC = ({ children }) => {
  const [multaSelecionada, setMultaSelecionada] = useState<IGraduacaoMultasGetAllResponse>()
  const [areasObjList, setAreasObjList] = useState<IAreasAtuacaoResponse[]>()
  const [faixaFuncionariosObjList, setFaixaFuncionariosObjList] = useState<IFaixaFuncionariosResponse[]>()
  const [infracoesObjList, setinfracoesObjList] = useState<IInfracoesResponse[]>()

  return (
    <FineGraduationContext.Provider
      value={{
        areasObjList,
        faixaFuncionariosObjList,
        infracoesObjList,
        multaSelecionada,
        setAreasObjList,
        setFaixaFuncionariosObjList,
        setMultaSelecionada,
        setinfracoesObjList,
      }}
    >
      {children}
    </FineGraduationContext.Provider>
  )
}
